<template>
  <div class="autumn-course-product-list">
    <a class="product-item"
       v-for="(item, index) in list"
       :key="index"
       :href="item.productPath"
       target="_blank"
    >
      <img class="cover"
           :src="item.cover"
           :alt="item.title"
      />
      <div class="item-info">
        <div class="item-title ym-two-line-ellipsis"
             v-html="item.title"
        ></div>
        <div class="item-desc">{{ item.time }}</div>
        <div class="action-block">
          <div class="join-price"
               :class="{ 'disabled': item.status !== 'canJoin' }"
          >
            ¥{{ item.price }}
          </div>
          <div class="join-btn"
               v-if="item.status === 'canJoin'"
          >
            查看详情
          </div>
          <div class="join-btn disabled"
               v-else-if="item.status === 'isOver'"
          >
            报名截止
          </div>
          <div class="join-btn disabled"
               v-else-if="item.status === 'isFull'"
          >
            名额已满
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
  import { isPC } from '@/utils';

  export default {
    name: 'AutumnCourseProductList2019',
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    computed: {
      inPC() {
        return isPC();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @color-highlight: #ff7508;

  .autumn-course-product-list {
    padding: 80px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fef4d7;
  }

  .product-item {
    width: 690px;
    padding: 20px 10px 20px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: @color-text-base;
    font-size: @font-size-extra-small;
    font-weight: @font-weight-bold;
    background: @color-white;
    box-shadow: 0 0 15px fade(#d85700, 15%);
    &:not(:last-child) {
      margin-bottom: @size-medium;
    }
  }

  .cover {
    width: 306px;
    height: 226px;
    display: block;
    flex-shrink: 0;
    margin-right: @size-small;
  }

  .item-info {
    align-self: stretch;
    flex: 1;
  }
  .item-title {
    margin-bottom: 16px;
    font-size: 26px;
    line-height: 1.6;
  }
  .item-desc {
    margin-bottom: 16px;
    font-weight: @font-weight-primary;
    line-height: 1.2;
  }
  .item-hint {
    margin-bottom: 16px;
    color: @color-highlight;
    line-height: 1.2;
    &.disabled {
      color: @color-text-lighter;
      font-weight: @font-weight-primary;
    }
  }
  .action-block {
    margin-top: @size-base;
    width: 300px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 24px;
    box-sizing: border-box;
  }
  .join-price {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #ff7508;
    border: 1px solid #ff7508;
    box-sizing: border-box;
    border-radius: 24px 0 0 24px;
    line-height: 1;
    &.disabled {
      border-color: #eee;
      color: @color-text-lighter;
      font-weight: @font-weight-primary;
    }
  }
  .join-btn {
    width: 150px;
    height: 50px;
    line-height: 50px;
    border-radius: 0 24px 24px 0;
    background: @color-highlight;
    color: @color-white;
    font-weight: @font-weight-bold;
    font-size: 26px;
    text-align: center;
    &.disabled {
      background: #eee;
      color: @color-text-lighter;
      font-weight: @font-weight-primary;
    }
  }

</style>
